module.exports = __webpack_public_path__ + "static/NO-streaming-video-gamiclub-tallyman.v1-pin/files/53eeb6cc62fc0308cf0edbdf26a48350.svg";